<template lang="html">
  <swiper :options="swiperOption" ref="mySwiper">
    <swiper-slide v-for="file in project.files" :key="file.id">
      <img :src="file.url" :alt="project.title">
    </swiper-slide>
    <div class="swiper-prev" slot="button-prev"></div>
    <div class="swiper-next" slot="button-next"></div>
  </swiper>
</template>

<script>
export default {
  props: {
    project: Object
  },
  data () {
    return {
      swiperOption: {
        loop: true,
        navigation: {
          nextEl: '.swiper-next',
          prevEl: '.swiper-prev'
        }
      }
    }
  },
}
</script>

<style lang="css" scoped>
.swiper-prev, .swiper-next {
  position: absolute;
  top:0;
  left:0;
  height:100%;
  width:20%;
  z-index:5;
  cursor:w-resize;
  background:rgba(255,0,0,0);
}
.swiper-next {
  left:auto;
  right:0;
  cursor:e-resize;
}
</style>
